
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.25 40c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z","fill":"currentColor"}}),_c('g',{attrs:{"clip-path":"url(#clip0_4302_40861)"}},[_c('path',{attrs:{"d":"M17.756 11.09h-2.97a.993.993 0 00-.99.99v15.84c0 .544.446.99.99.99h2.97c.545 0 .99-.446.99-.99V12.08a.993.993 0 00-.99-.99zm7.92 0h-2.97a.993.993 0 00-.99.99v15.84c0 .544.446.99.99.99h2.97c.544 0 .99-.446.99-.99V12.08a.993.993 0 00-.99-.99z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4302_40861"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8.25 8)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    